export default __webpack_public_path__ + "static/media/SmartPlug.747e730a.svg";